import React, { useState } from "react";
import { useEffect } from "react"
import App from "../App";


export const RNListener = () => {
  const [token, setToken] = useState(null);
  
  useEffect(() => {
    if (window.ReactNativeWebView) {
      console.log('set RN message Listener')
      // android
      document.addEventListener("message", listener);
      // ios
      window.addEventListener("message", listener);
    }

    return () => {
      document.removeEventListener("message", listener);
      window.removeEventListener("message", listener);
    }
  }, [])

  const listener = (event: any) => {
    // console.log(JSON.parse(event.data));
    const { data, type } = JSON.parse(event.data);

    if (type === "TOKEN") {
      // console.log('TOKEN??', data)
      setToken(data);
    } else if (type === "NOTIFICATION") {
      // console.log('NOT TOKEN!!')
    }
  };

  return (
    <React.Fragment>
      <App token={token}/>
    </React.Fragment>
  )
}